import React from "react";
import { styled } from "@mui/material/styles";

const BackgroundContainer = styled("div")(({ isEmbedded }) => ({
  position: isEmbedded ? "absolute" : "fixed",
  top: 0,
  left: 0,
  width: "100%",
  height: "100%",
  overflow: "hidden",
  zIndex: -1,
  pointerEvents: "none",
  backgroundColor: "#F2EAF7",
}));

/** Poster image stack for broad format support (avif > webp > jpg). */
const StaticBackgroundLayer = styled("picture")({
  position: "absolute",
  inset: 0,
  display: "block",
  backgroundColor: "#F2EAF7",
});

const StaticBackgroundImage = styled("img")({
  width: "100%",
  height: "100%",
  objectFit: "cover",
  objectPosition: "center",
  display: "block",
  backgroundColor: "#F2EAF7",
  backgroundSize: "cover",
  backgroundPosition: "center",
  backgroundRepeat: "no-repeat",
});

/**
 * App shell background: static poster only (no looping video decode).
 *
 * @param {object} props
 * @param {boolean} [props.isEmbedded=false]
 * @returns {React.ReactElement}
 */
function StaticBackground({ isEmbedded = false }) {
  return (
    <BackgroundContainer isEmbedded={isEmbedded}>
      <StaticBackgroundLayer>
        <source srcSet="/web_bg_poster.avif" type="image/avif" />
        <source srcSet="/web_bg_poster.webp" type="image/webp" />
        <StaticBackgroundImage
          src="/web_bg_poster.jpg"
          loading="eager"
        />
      </StaticBackgroundLayer>
    </BackgroundContainer>
  );
}

/**
 * @deprecated Prefer {@link StaticBackground} (default export from `@/components/Background`). Kept for backward compatibility.
 * @param {object} props
 * @param {boolean} [props.isEmbedded=false]
 * @returns {React.ReactElement}
 */
function AnimatedBackground(props) {
  return <StaticBackground {...props} />;
}

export default StaticBackground;
export { StaticBackground, AnimatedBackground };
